export default [
    25,
    50,
    100
];
